import { GetItemsProps } from "medere-ui-framework";
import { axiosInstance } from "../App";

export function healthcheck() {
    return axiosInstance.get('/api/secured/medereendpoints/getVersion', {
        params: {
            'token': 'cfee9a61-e9e2-4deb-b017-46b6136c193a'
        }
    }).then((response) => {
        return response;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}
